import React from 'react'
type SpinerProps = {
    className?: string,
    classSvg?: string,
}
const Spiner = ({ className = "h-[300px]", classSvg = "" }: SpinerProps) => {
    return (
        <div className={`flex justify-center items-center ${className}`}>
            <svg className={`${classSvg} absolute size-14`} viewBox="0 0 100 100">
                <circle
                    className="text-black/10 stroke-current stroke-[12]"
                    strokeWidth="12"
                    strokeLinecap="round"
                    cx="50"
                    cy="50"
                    r="40"
                    fill="none"
                    transform="rotate(-90 ) translate(-100 0)"
                    style={{
                        strokeDasharray: "315",
                        strokeDashoffset: "0",
                    }}
                />
            </svg>
            <svg className={`${classSvg} animate-spin size-14`} viewBox="0 0 100 100">
                <circle
                    className="text-primary stroke-current stroke-[12]"
                    strokeLinecap="round"
                    cx="50"
                    cy="50"
                    r="40"
                    fill="none"
                    transform="rotate(-90 ) translate(-100 0)"
                    style={{
                        strokeDasharray: "315",
                        strokeDashoffset: "200",
                    }}
                />
            </svg>
        </div>
    )
}
export default Spiner